import { UserType } from '../../types/userTypes'
import { Cta } from './Cta'

export const CtasPdl: { readonly [key in UserType]: readonly Readonly<Cta>[] } = {
  [UserType.Consumer]: [],
  [UserType.Electrician]: [],
}
